
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  defineComponent, provide, reactive, watch,
} from 'vue';
import { cloneDeep } from 'lodash';
import {
  Button, Form, Modal, Select,
} from 'ant-design-vue';
import asynButtonVue from '@/components/asynButton.vue';
import Single from './single.vue';
import Multiple from './multiple.vue';
import TrueOrFalse from './trueOrFalse.vue';
import Blank from './blank.vue';
import { questionTypes, reverseData } from './js/index';
import {
  ParseQuestionI, Question, PMeta,
} from './js/interface';

export default defineComponent({
  name: 'Question',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => new Question(),
    },
  },
  components: {
    aModal: Modal,
    aForm: Form,
    aFormItem: Form.Item,
    aSelect: Select,
    aOption: Select.Option,
    Single,
    Multiple,
    TrueOrFalse,
    Blank,
    aButton: asynButtonVue,
  },
  setup(props, { emit }) {
    const newKey = {
      pMetas: [] as PMeta[],
      pAnswer: [] as Array<number|string|boolean|undefined>,
    };
    // 初始化时当增加处理，用newKey覆盖data
    const dataClone = reactive(cloneDeep({ ...props.data, ...newKey })) as unknown as ParseQuestionI;

    const handleQTypeChange = (qtype: number, dClone: ParseQuestionI) => {
      switch (qtype) {
        case 0:
          dClone.pAnswer = [undefined];
          break;
        case 1:
          dClone.pAnswer = [];
          break;
        case 2:
          dClone.pAnswer = [undefined];
          dClone.pMetas = [];
          break;
        default:
          dClone.pAnswer = [''];
          dClone.pMetas = [];
      }
    };

    watch(() => props.data as Question, (data: Question) => {
      if (data.id) {
        Object.assign(dataClone, reactive(cloneDeep({ ...newKey, ...data })));
      } else {
        Object.assign(dataClone, reactive(cloneDeep({ ...data, ...newKey })));
      }
    }, { deep: true });
    watch(() => props.visible, (v: boolean) => {
      if (!v) Object.assign(dataClone, reactive(cloneDeep({ ...props.data, ...newKey })));
    });

    provide('dataClone', dataClone);

    const currentComponent = (qtype: number) => ['Single', 'Multiple', 'TrueOrFalse', 'Blank'][qtype];

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let validate: Function = () => {};
    const handleEmitValidate = (va: Function) => {
      validate = va;
    };
    const handleOk = () => {
      const isValid = validate();
      if (isValid) {
        emit('ok', reverseData(dataClone));
      }
    };

    const handleCancel = () => {
      emit('cancel');
    };

    return {
      dataClone,
      questionTypes,
      handleQTypeChange,
      currentComponent,
      handleOk,
      handleCancel,
      handleEmitValidate,
    };
  },
});
